var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 23c0 12.565-10.185 22.75-22.75 22.75S.25 35.565.25 23 10.435.25 23 .25 45.75 10.435 45.75 23Z",
    fill: "#fff",
    stroke: "#383D51",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.358 39.8c8.6 0 8.6-.128 10.058-.56 1.904-.566-5.38-5.609-10.058-5.609s-8.47 1.38-8.47 3.084c0 1.704 3.792 3.085 8.47 3.085Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.885 13.569.395.426-.346.467C24.72 29.626 18.258 36.492 15.517 35.571c-1.67-.561-3.344-2.248-5.018-4.697a34.592 34.592 0 0 1-1.644-2.67 29.045 29.045 0 0 1-.765-1.458 3.632 3.632 0 0 1-.33-.954l-.008-.039a3.493 3.493 0 0 0-.055-.251A15.29 15.29 0 0 1 29.922 8.225l.058.036c1.85 1.288 3.817 3.057 5.905 5.308Zm-6.677-4.137a13.89 13.89 0 0 0-20.155 15.71c.03.115.044.18.076.345l.007.034c.042.217.116.427.22.623.134.281.403.803.724 1.378a33.242 33.242 0 0 0 1.576 2.56c1.513 2.214 3.013 3.725 4.308 4.16 1.726.58 8.225-6.3 18.495-20.143-1.864-1.969-3.615-3.524-5.251-4.667Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.207 9.432a13.89 13.89 0 0 0-20.154 15.71c.03.115.044.18.076.345l.007.034c.042.217.116.427.22.622.134.282.403.803.724 1.379a33.223 33.223 0 0 0 1.576 2.56c1.513 2.213 3.013 3.725 4.308 4.16 1.726.58 8.225-6.3 18.495-20.143-1.865-1.969-3.615-3.524-5.252-4.667Z",
    fill: "#EC1C79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.275 39.66a15.284 15.284 0 1 1 0-30.567 15.284 15.284 0 0 1 0 30.567Zm0-1.401a13.88 13.88 0 1 0 0-27.761 13.88 13.88 0 0 0 0 27.76Z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.276 38.258a13.881 13.881 0 1 0 0-27.763 13.881 13.881 0 0 0 0 27.763Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.892 27.22-1.838-5.535h1.61l.958 3.18 1.06-3.196h1.312l1.06 3.196.958-3.18h1.578l-1.838 5.535h-1.327l-1.107-3.164-1.1 3.164h-1.326Zm7.302-.039v-5.496h4.42v1.295h-2.912v.833h2.638v1.201h-2.638v.872h2.952v1.295h-4.46Zm6.58 0V23.02h-1.649v-1.335h4.821v1.335h-1.649v4.161h-1.523Zm3.84 0v-5.496h1.523v2.057h1.955v-2.057h1.523v5.496h-1.523v-2.088h-1.955v2.088h-1.523Z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.098 20.032a.785.785 0 0 1 .702-1.405l2.244 1.122a.786.786 0 1 1-.703 1.404l-2.243-1.121Zm-.258 3.719a.785.785 0 1 1 .658-1.426l2.244 1.036a.786.786 0 1 1-.659 1.425L7.84 23.752Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeth);
export default __webpack_public_path__ + "static/media/weth.72bb21b74ebff55ff915113484d1f1cd.svg";
export { ForwardRef as ReactComponent };